var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widget-title" }, [
    _c(
      "div",
      { staticClass: "title-content", on: { click: _vm.startTitleEdit } },
      [
        !_vm.isEditingTitle
          ? [
              _c("span", { staticClass: "title-text" }, [
                _vm._v(_vm._s(_vm.widget.title)),
              ]),
              _vm._v(" "),
              _c("i", { staticClass: "material-icons edit-icon" }, [
                _vm._v("edit"),
              ]),
            ]
          : _c("a-input", {
              ref: "titleInput",
              attrs: { defaultValue: _vm.widget.title },
              on: { pressEnter: _vm.saveTitleEdit, blur: _vm.saveTitleEdit },
              model: {
                value: _vm.editingTitle,
                callback: function ($$v) {
                  _vm.editingTitle = $$v
                },
                expression: "editingTitle",
              },
            }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }